import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=434625f6"
import script from "./Treatment.vue?vue&type=script&lang=ts"
export * from "./Treatment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports